<template>
  <modal size="xl" :title="'Temp Reservation'" @close="$emit('close')">
    >
    <template #content>
      <div
        v-if="data != null"
        class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
      >
        <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
          <Btn
            class="btn btn-primary btn-icon waves-effect waves-light p-r-20 m-l-5"
            type="button"
            @click="sendToQueue"
            :disabled="selectCount == 0"
          >
            <span class="btn-label m-0 p-0"><i class="mdi mdi-layers-off"></i></span>
            <span class="p-l-20 p-r-10"
              >{{ selectCount > 0 ? "(" + selectCount + ") " : "" }}Send to Reset
              Queue</span
            >
          </Btn>
        </div>
        <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
          <Btn
            class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
            type="button"
            @click="add"
            :process="process"
          >
            <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
            <span class="p-l-20 p-r-10">Add Temp Reservation</span>
          </Btn>
        </div>
      </div>
      <load-area v-if="data == null"></load-area>

      <div class="rel" v-if="data != null">
        <div
          class="myCheckBox abs"
          style="top: 47px; z-index: 5; left: 6px;"
        >
          <input
            type="checkbox"
            class="filled-in"
            v-model="selectAll"
            id="chckMassFidelio"
          /><label for="chckMassFidelio"></label>
        </div>
        <dataTable
          :name="'CustomerProviderHotelCodes'"
          ref="agGrid"
          :columnDefs="columnDefs"
          :data="data"
          :addContextMenuItem="getContextMenuItems"
          @cellClicked="onCellClicked"
          @update="updatePopShow = $event"
          @remove="remove"
        ></dataTable>
      </div>
    </template>
  </modal>
</template>

<script>
import moment from "moment";
export default {
  name: "TempReservation",
  props: ["hotel"],
  data() {
    return {
      columnDefs: [
        {
          headerName: "",
          width: 55,
          filter: false,
          field: "isSelected",
          sortable: false,
          cellClick: true,
          enableRowGroup: false,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 60,
        },
        {
          headerName: "ReservationCode",
          field: "ReservationCode",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: "DefaultDate",
          field: "DefaultDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            return moment(new Date(params.value)).format("DD-MM-YYYY HH:mm");
          },
        },
        {
          headerName: "LastUsingDate",
          field: "LastUsingDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            return moment(new Date(params.value)).format("DD-MM-YYYY HH:mm");
          },
        },
        {
          headerName: "LastUserId",
          field: "LastUserId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 110,
        },
        {
          headerName: "LastReservationId",
          field: "LastReservationId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: "ProfileId",
          field: "ProfileId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Reseted",
          field: "Reseted",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 100,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "IsUsing",
          field: "IsUsing",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 90,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Active",
          field: "Active",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 90,
          cellRenderer: this.$CheckCellRenderer,
        },
      ],
      data: null,
      process: false,
      selectAll: false,
      selectCount: 0,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get("pms/13/GetTempReservations/" + this.hotel.Id)
      .then((response) => {
        this.data = response.data.map((x) => ({ ...x, isSelected: false }));
      });
  },
  watch: {
    selectAll() {
      if (!this.selectAll) {
        this.data.forEach((element) => {
          if (element.isSelected) {
            element.isSelected = false;
            this.$refs.agGrid.changeRow("Id", element);
          }
        });
        this.updateSelectCount();
        return;
      }
      if (!this.$refs.agGrid?.gridApi) {
        return;
      }
      const currentPage = this.$refs.agGrid.gridApi.paginationGetCurrentPage();
      const pageSize = this.$refs.agGrid.gridApi.paginationGetPageSize();
      let pager = {
        min: currentPage * pageSize,
        max: (currentPage + 1) * pageSize,
      };
      this.$refs.agGrid.gridApi.forEachNodeAfterFilterAndSort(
        (rowNode, index) => {
          if (index >= pager.min && index < pager.max) {
            this.$refs.agGrid.changeRow("Id", {
              ...rowNode.data,
              isSelected: true,
            });
          }
        }
      );
      this.updateSelectCount();
    },
  },
  methods: {
    updateSelectCount() {
      this.selectCount = this.data.filter((x) => x.isSelected).length;
    },
    onCellClicked(param) {
      if (param.colDef.field == "isSelected") {
        this.$refs.agGrid.changeRow("Id", {
          ...param.data,
          isSelected: !param.data.isSelected,
        });
        this.updateSelectCount();
      }
    },
    resetSelection() {
      this.data.forEach((element) => {
        if (element.isSelected) {
          element.isSelected = false;
          this.$refs.agGrid.changeRow("Id", element);
        }
      });
      this.selectAll = false;
      this.updateSelectCount();
    },
    sendToQueue() {
      const rows = this.data.filter((x) => x.isSelected);
      if (!rows.length) return;
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to send the selected items to the reset queue?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (!question.isConfirmed) return;
        const body = rows.map((r) => ({
          HotelId: r.HotelId,
          TempReservationId: r.Id,
        }));
        this.$appAxiosAdmin
          .post("TempReservations/QueueReset", body)
          .then((response) => {
            const { queued = [], skipped = [], failed = [] } = response.data;
            this.resetSelection();
            this.$swal({
              icon: failed.length ? "warning" : "success",
              title: "Reset Queue",
              html: [
                "📤 Sent: " + rows.length,
                queued.length
                  ? '<span style="color:#28a745">✓</span> Queued: ' +
                    queued.length
                  : null,
                skipped.length
                  ? '<span style="color:#ffc107">⏭</span> Skipped: ' +
                    skipped.length
                  : null,
                failed.length
                  ? '<span style="color:#dc3545">✗</span> Failed: ' +
                    failed.length
                  : null,
              ]
                .filter(Boolean)
                .join("<br>"),
              confirmButtonText: "Okey",
            });
          })
          .catch((err) => {
            this.$isError(err);
          });
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Reset Temp Reservation",
          icon: "<i class='mdi mdi-sync'></i>",
          action: () => {
            this.resetTempReservation(params.node.data);
          },
        },{
          name: params.node.data.Active ? "Passive" : "Active",
          icon:
            "<i class='fas " +
            (params.node.data.Active ? "fa-square" : "fa-check-square") +
            "'></i>",
          action: () => {
            this.$appAxiosAdmin
              .get(
                "pms/13/TempReservations/" +
                  params.node.data.Id +
                  "/UpdateActive?active=" +
                  !params.node.data.Active
              )
              .then(() => {
                this.$refs.agGrid.changeRow("Id", {
                  ...params.node.data,
                  Active: !params.node.data.Active,
                });
              })
              .catch((err) => {
                this.$isError(err);
              });
          },
        },
      ];
      return result;
    },
    resetTempReservation(item) {
      this.$appAxiosAdmin
        .get(`pms/13/ResetTempReservation/` + item.HotelId + "/" + item.Id)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Temporary reservation reset successfully.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    add() {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Are you sure you want to add a temp reservation?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.process = true;
          this.$appAxiosAdmin
            .get(`pms/13/AddTempReservation/` + this.hotel.Id)
            .then((response) => {
              this.$refs.agGrid.addRow([response.data]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Temp reservation added successfully",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.process = false;
            })
            .catch((err) => {
              this.$isError(err);
              this.process = false;
            });
        }
      });
    },
  },
};
</script>

<style></style>
